(() => {
  if (!customElements.get('ck-launch-signup')) customElements.define('ck-launch-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const interest = this.querySelector('[data-launch-interest]');
      const tags = this.querySelector('[data-launch-tags]');
      const update = () => {
        const source = new URLSearchParams(location.search).get('utm_source');
        const cleanSource = source ? source.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0,40) : '';
        tags.value = ['newsletter','cutekit-prelaunch',interest.value,cleanSource ? 'source-'+cleanSource : 'source-direct-or-unattributed'].join(',');
      };
      interest.addEventListener('change',update);
      form.addEventListener('submit',update);
      update();
    }
  });
  document.addEventListener('submit', event => {
    const form=event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.action.includes('/cart/add') || (form.action.endsWith('/cart') && event.submitter?.name==='checkout')) {
      event.preventDefault(); event.stopImmediatePropagation();
      document.querySelector('ck-launch-signup')?.scrollIntoView({behavior:'smooth',block:'center'});
    }
  },true);
})();